import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { constEvent } from '../../utils/constants';
import { dispatchGenericEvent } from '../../utils/dispatch-events';
import EventListingPerson from './event-listing-person';

const EventListingItem = props => {
  const externalIcon = (
    <svg className="btn__icon" width="20" height="20">
      <use xlinkHref="#external" />
    </svg>
  );

  let onRegisterClick = () => {
    dispatchGenericEvent(
      constEvent.OPEN_ELOQUA_IFRAME_MODAL,
      {
        url: props.register.url
      },
      props.modal
    );
  };

  onRegisterClick = useCallback(onRegisterClick, [onRegisterClick]);

  const renderRegisterLink = () => {
    const commonButtonClasses =
      'btn btn--primary btn--full-width event-listing-item__register';
    if (!props.register) return null;
    if (props.register.isInternal) {
      return (
        <button onClick={onRegisterClick} className={commonButtonClasses}>
          <span>{props.labelRegister}</span>
        </button>
      );
    }
    if (!props.register.isInternal) {
      return (
        <a
          target={props.register.target}
          href={props.register.url}
          className={commonButtonClasses}
        >
          <span>{props.labelRegister}</span>
        </a>
      );
    }
  };

  const renderCtaClasses = style => {
    const common = 'event-listing-item__cta';

    if (style === 'primary') {
      return `btn btn--primary btn--full-width ${common}`;
    }

    if (style === 'secondary') {
      return `btn btn--secondary btn--full-width ${common}`;
    }

    if (style === 'tertiary') {
      return `link link--primary link--with-arrow ${common}`;
    }

    return `btn btn--primary ${common}`;
  };

  return (
    <li className="event-listing-item">
      <div className="event-listing-item__image-content-wrapper">
        {!!props.image && (
          <a href={props.url}>
            <img
              className="event-listing-item__image"
              src={props.image}
              alt={props.name}
            />
          </a>
        )}
        <div className="event-listing-item__content">
          <h3 className="event-listing-item__name">
            <a href={props.url}>{props.name}</a>
          </h3>
          {props.location && (
            <p className="event-listing-item__location">{props.location}</p>
          )}
          <p className="event-listing-item__date">{props.date}</p>
          {!!props.teaser && (
            <p className="event-listing-item__teaser" dangerouslySetInnerHTML={{ __html:props.teaser }}></p>
          )}
          {!!props.persons && props.persons.length ? (
            <Fragment>
              <h4 className="event-listing-item__persons-title">
                {props.labelPersons}
              </h4>
              <ul className="event-listing-item__persons">
                {props.persons.map(p => (
                  <EventListingPerson key={p.id} {...p} />
                ))}
              </ul>
            </Fragment>
          ) : null}
        </div>
      </div>
      <div className={`event-listing-item__actions ${props.image ? ' ' : 'no-img'}`}>
        <div className="event-listing-item__actions-inner">
          {renderRegisterLink()}
          {props?.ctas?.map?.((a, i) => (
            <a
              key={a.url + i}
              href={a.url}
              target={a.target}
              className={renderCtaClasses(a.style)}
            >
              {a.isExternal && externalIcon}
              <span>{a.label}</span>
            </a>
          ))}
        </div>
      </div>
    </li>
  );
};

EventListingItem.propTypes = {
  target: PropTypes.string,
  persons: PropTypes.array,
  location: PropTypes.string,
  register: PropTypes.shape({
    target: PropTypes.string
  }),
  ctas: PropTypes.array
};

EventListingItem.defaultProps = {
  persons: [],
  ctas: []
};

export default EventListingItem;
